import React, { useState, useEffect } from "react";
//style
import { Card, CardBody, CardTitle, Col, Row, Button } from "reactstrap";
//redux
import { connect } from "react-redux";
//service
import { verifyLogin, insertNewAccessListApi } from "../../utils/service/login";

function FormLogin(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [terms, setTerms] = useState();
  const [termsDisable, setTermsDisable] = useState(true);
  //state error
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState("");

  function termsDisableFunc() {
    if (name && email && terms) {
      setTermsDisable(false);
    } else setTermsDisable(true);
  }

  function submitForm(e) {
    //verificar campos vazios
    if (!e.target[0].value) {
      setNameError(true);
      setTimeout(() => {
        document.getElementById("input-login-name").focus();
      }, "500");
      return;
    } else setNameError(false);

    if (!e.target[1].value) {
      setEmailError("O campo Email é obrigatório");
      setTimeout(() => {
        document.getElementById("input-login-email").focus();
      }, "500");
      return;
    } else setEmailError("");

    //verificar existência do email na api
    verifyLogin(e.target[1].value)
      .then((response) => {
        if (response.success) {
          insertNewAccessListApi(response.data).then(() => {
            props.setToken(response.message);
            props.setUser(response.data);
            window.open("/home", "_parent");
          });
        } else {
          setEmailError("Email inválido");
          setTimeout(() => {
            document.getElementById("input-login-email").focus();
          }, "500");
        }
      })
      .catch((error) => {
        setEmailError("Email inválido");
      });
  }

  useEffect(() => {
    termsDisableFunc();
  }, [name, email, terms]);
  return (
    <Row style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Col md={6} style={{ padding: 0, margin: 0 }}>
        <Card style={{ marginBottom: 10 }}>
          <CardBody style={{ padding: 30 }}>
            <CardTitle
              style={{ textAlign: "center", fontSize: 18 }}
              tabIndex={1}
            >
              Página de Login
            </CardTitle>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                submitForm(e);
              }}
            >
              <Row>
                <div className="col-md-12">
                  <label className="form-label" tabIndex={2}>
                    Nome Completo*
                  </label>
                  {nameError && (
                    <p
                      style={{ color: "red", marginBottom: 0 }}
                      tabIndex={3}
                      id="input-login-name"
                    >
                      O campo Nome é obrigatório
                    </p>
                  )}
                  <input
                    className="form-control"
                    type="text"
                    // placeholder="Nome Completo*"
                    onChange={(e) => setName(e.target.value)}
                    tabIndex={4}
                    title="Insira seu nome completo"
                  />
                </div>
              </Row>
              <Row style={{ marginTop: 20 }}>
                <div className="col-md-12">
                  <label className="form-label" tabIndex={5}>
                    Email*
                  </label>
                  {emailError && (
                    <p
                      style={{ color: "red", marginBottom: 0 }}
                      tabIndex={6}
                      id="input-login-email"
                    >
                      {emailError}
                    </p>
                  )}
                  <input
                    className="form-control"
                    type="text"
                    // placeholder="Email*"
                    onChange={(e) => setEmail(e.target.value)}
                    tabIndex={7}
                    title="Insira seu email"
                  />
                </div>
              </Row>

              <div tabIndex={8}>
                <p
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    marginTop: 10,
                  }}
                  tabIndex={-1}
                >
                  Termo de Consentimento para Tratamento de Dados
                </p>
                <div
                  style={{
                    margin: "20px 0",
                    maxHeight: 150,
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <p tabIndex={-1}>
                    Este documento visa registrar a manifestação livre,
                    informada e inequívoca pela qual o Titular concorda com o
                    tratamento de seus dados pessoais para finalidade
                    específica, em conformidade com a{" "}
                    <a
                      href="https://www.gov.br/defesa/pt-br/acesso-a-informacao/lei-geral-de-protecao-de-dados-pessoais-lgpd"
                      target={"_blank"}
                      tabIndex={-1}
                    >
                      Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais
                      (LGPD)
                    </a>
                    .
                  </p>
                </div>
                {/* <p style={{ fontWeight: "bold" }}>Dados Pessoais</p>
                <p>
                  A Controladora fica autorizada a tomar decisões referentes ao
                  tratamento e a realizar o tratamento dos seguintes dados
                  pessoais do Titular:
                </p>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <a style={{ fontWeight: "bold" }}>
                    ° Listar todos os dados coletados (seja via Landipage /
                    Importado por Planilha / Cadastro direto no HALL
                  </a>
                  <a>
                    ° Nome de usuário e senha específicos para uso dos serviços
                    do Controlador;
                  </a>
                  <a>° Vídeos, fotos e textos de postados pelo Titular;</a>
                  <a>° Histórico de chat publico ou privado;</a>
                  <a>° Histórico de navegação pela plataforma;</a>
                  <a>
                    ° Comunicação, verbal e escrita, mantida entre o Titular e o
                    Controlador.
                  </a>
                </p>
                <p style={{ fontWeight: "bold" }}>
                  Da Finalidades do Tratamento dos Dados
                </p>
                <p>
                  O tratamento dos dados pessoais listados neste termo tem as
                  seguintes finalidades:
                </p>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <a>° Possibilitar o acesso único e seguro ao evento;</a>
                  <a>
                    ° Possibilitar que a Controladora utilize tais dados na
                    inscrição, divulgação, premiação dos interessados
                    participantes de Eventos, Prêmios ou Concursos;
                  </a>
                  <a>
                    ° Possibilitar que a Controladora possa utilizar os dados
                    para encaminhar mensagens por meios físicos e digitais,
                    abrangendo correio eletrônico (e-mail), SMS, WhatsApp e
                    Notificações via Push;
                  </a>
                  <a>
                    ° Possibilitar que a Controladora utilize tais dados na
                    elaboração de relatórios;
                  </a>
                  <a>
                    ° Possibilitar que a Controladora utilize tais dados para
                    suas peças de Comunicação;
                  </a>
                  <a>
                    ° Possibilitar que a Controladora utilize tais dados para
                    manter banco de dados para facilitar o contato em futuros
                    convites para eventos;
                  </a>
                </p>
                <p style={{ fontWeight: "bold" }}>Compartilhamento de Dados</p>
                <p>
                  A Controladora fica autorizada a compartilhar os dados
                  pessoais do Titular com outros agentes de tratamento de dados,
                  caso seja necessário para as finalidades listadas neste termo,
                  observados os princípios e as garantias estabelecidas pela Lei
                  nº 13.709.
                </p>
                <p style={{ fontWeight: "bold" }}>Segurança dos Dados</p>
                <p>
                  A Controladora responsabiliza-se pela manutenção de medidas de
                  segurança, técnicas e administrativas aptas a proteger os
                  dados pessoais de acessos não autorizados e de situações
                  acidentais ou ilícitas de destruição, perda, alteração,
                  comunicação ou qualquer forma de tratamento inadequado ou
                  ilícito.
                </p>
                <p>
                  Em conformidade ao art. 48 da Lei nº 13.709, o Controlador
                  comunicará ao Titular e à Autoridade Nacional de Proteção de
                  Dados (ANPD) a ocorrência de incidente de segurança que possa
                  acarretar risco ou dano relevante ao Titular.
                </p>
                <p style={{ fontWeight: "bold" }}>
                  Término do Tratamento dos Dados
                </p>
                <p>
                  A Controladora poderá manter e tratar os dados pessoais do
                  Titular durante todo o período em que os mesmos forem
                  pertinentes ao alcance das finalidades listadas neste termo.
                  Dados pessoais anonimizados, sem possibilidade de associação
                  ao indivíduo, poderão ser mantidos por período indefinido.
                </p>
                <p>
                  O Titular poderá solicitar via e-mail ou correspondência ao
                  Controlador, a qualquer momento, que sejam eliminados os dados
                  pessoais não anonimizados do Titular. O Titular fica ciente de
                  que poderá ser inviável ao Controlador continuar o
                  fornecimento de produtos ou serviços ao Titular a partir da
                  eliminação dos dados pessoais.
                </p>
                <p style={{ fontWeight: "bold" }}>Direitos do Titular</p>
                <p>
                  O Titular tem direito a obter da Controladora, em relação aos
                  dados por ele tratados, a qualquer momento e mediante
                  requisição: I - confirmação da existência de tratamento; II -
                  acesso aos dados; III - correção de dados incompletos,
                  inexatos ou desatualizados; IV - anonimização, bloqueio ou
                  eliminação de dados desnecessários, excessivos ou tratados em
                  desconformidade com o disposto na Lei nº 13.709; V -
                  portabilidade dos dados a outro fornecedor de serviço ou
                  produto, mediante requisição expressa e observados os segredos
                  comercial e industrial, de acordo com a regulamentação do
                  órgão controlador; V - portabilidade dos dados a outro
                  fornecedor de serviço ou produto, mediante requisição
                  expressa, de acordo com a regulamentação da autoridade
                  nacional, observados os segredos comercial e industrial; VI -
                  eliminação dos dados pessoais tratados com o consentimento do
                  titular, exceto nas hipóteses previstas no art. 16 da Lei nº
                  13.709; VII - informação das entidades públicas e privadas com
                  as quais o controlador realizou uso compartilhado de dados;
                  VIII - informação sobre a possibilidade de não fornecer
                  consentimento e sobre as consequências da negativa; IX -
                  revogação do consentimento, nos termos do § 5º do art. 8º da
                  Lei nº 13.709.
                </p>
                <p style={{ fontWeight: "bold" }}>
                  Direito de Revogação do Consentimento
                </p>
                <p>
                  Este consentimento poderá ser revogado pelo Titular, a
                  qualquer momento, mediante solicitação via e-mail ou
                  correspondência ao Controlador.
                </p> */}
              </div>
              <Row>
                <div className="col-md-12">
                  <div>
                    <input
                      type="checkbox"
                      className="form-check-Input"
                      id="theme1"
                      onChange={(e) => setTerms(e.target.checked)}
                      tabIndex={9}
                    />
                    <label
                      className="form-check-Label"
                      htmlFor="theme1"
                      style={{ marginLeft: 5 }}
                    >
                      Li e concordo com os Termos*
                    </label>
                  </div>
                </div>
              </Row>
              <Row style={{ margin: "20px 0 0 0" }}>
                <button
                  // to={"/home"}
                  className="btn btn-success"
                  tabIndex={10}
                  title={"Entrar no sistema"}
                  type="submit"
                  disabled={termsDisable}
                >
                  Entrar
                </button>
              </Row>
              <Row
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  className="btn-back"
                  onClick={() => props.setStep("_a")}
                  tabIndex={11}
                  title="Voltar à escolha"
                >
                  Voltar
                </button>
              </Row>
            </form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

const mapDispatchToProps = function (dispatch) {
  return {
    setToken: (data) => {
      return dispatch({ type: "SET_TOKEN", data });
    },

    setUser: (data) => {
      return dispatch({ type: "SET_USER", data });
    },
  };
};

export default connect(null, mapDispatchToProps)(FormLogin);
